import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";



export default function StockConfirmModal({open, setOpen, onConfirm, part}){



    return (
        <Modal
            show={open}
            onClose={() => setOpen(false)}
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Confirm Stock Accrual Change</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={onConfirm}
                                fullwidth
                            >
                                Confirm
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={(e) => {e.stopPropagation(); setOpen(false);}}
                                fullwidth
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )
}